export const SHELL_TRANSLATIONS = {
  fr: {
    "shell.beta_summary": "Bêta · aucun paiement réel",
    "shell.learn_more": "En savoir plus",
    "shell.payments.prelaunch.badge": "Pré-lancement",
    "shell.payments.prelaunch.message": "Mode pré-lancement : aucun service financier réel n’est actif. Aucun achat/vente crypto, aucun dépôt/retrait fiat, aucun KYC.",
    "shell.payments.prelaunch.navigation": "Paiements bêta",
    "shell.payments.live.badge": "Paiements actifs",
    "shell.payments.live.message": "Les paiements réels sont disponibles uniquement dans les rubriques ouvertes. Les autres parcours restent en validation.",
    "shell.payments.live.navigation": "Paiements actifs",
    "shell.payments.sandbox.badge": "Paiements test actifs",
    "shell.payments.sandbox.message": "Paiements de test disponibles dans les rubriques activées ; la configuration ne vaut pas validation de tous les parcours. Aucun débit ni reversement réel n’est effectué.",
    "shell.payments.sandbox.navigation": "Paiements test",
    "shell.payments.sandbox-validating.badge": "Paiements test en validation",
    "shell.payments.sandbox-validating.message": "Stripe Connect est raccordé en environnement test. Les destinations de suivi et les parcours restent à valider ; aucun argent réel ne circule.",
    "shell.payments.sandbox-validating.navigation": "Paiements test",
  },
  en: {
    "shell.beta_summary": "Beta · no real payments",
    "shell.learn_more": "Learn more",
    "shell.payments.prelaunch.badge": "Pre-launch",
    "shell.payments.prelaunch.message": "Pre-launch mode: no real financial services are active. No cryptocurrency buying or selling, no fiat deposits or withdrawals, and no KYC.",
    "shell.payments.prelaunch.navigation": "Beta payments",
    "shell.payments.live.badge": "Payments active",
    "shell.payments.live.message": "Real payments are available only in enabled sections. Other journeys are still being validated.",
    "shell.payments.live.navigation": "Payments active",
    "shell.payments.sandbox.badge": "Test payments active",
    "shell.payments.sandbox.message": "Test payments are available in enabled sections; this configuration does not validate every journey. No real charges or payouts take place.",
    "shell.payments.sandbox.navigation": "Test payments",
    "shell.payments.sandbox-validating.badge": "Test payments under validation",
    "shell.payments.sandbox-validating.message": "Stripe Connect is connected in the test environment. Follow-up destinations and journeys still need validation; no real money moves.",
    "shell.payments.sandbox-validating.navigation": "Test payments",
  },
};
